@if(isTextDescriptionAvailable) {
<a class="text-sm text-gray-500 hover:text-gray-600" (click)="openModalConsent()">Cookie consent</a>
}
